import Repository from "./Repository";
const GET_QUOTE = "getall";
const CREATE_QUOTE = "Add";
const UPDATE_QUOTE = "edit";
const DELETE_QUOTE = "delete";
export default {
  get_quotes(payload) {
    return Repository.get(transformRoute(GET_QUOTE), {
      params: payload,
    });
  },
  add_quotes(payload) {
    return Repository.post(transformRoute(CREATE_QUOTE), payload);
  },
  update_quotes(payload) {
    return Repository.post(transformRoute(UPDATE_QUOTE), payload);
  },
  delete_quotes(payload) {
    return Repository.post(transformRoute(DELETE_QUOTE), payload);
  },
};

const transformRoute = (route) => {
  return `/cms/quotes/${route}`;
};
